import { useExtendedRmsUserDirectoryFilters } from '@/ui/features/contact-management/UserDIrectoryPanel/hooks/useExtendRmsUserDirectoryFilters';
import { FilterConfigBuilder } from '@juvare/common-data-table-ui/FiltersBar/utils';
import { UserDirectoryFilterData } from '@juvare/contact-management/ui/features/user-directory';
import { useExtendedCredentialingUserDirectoryFilters } from '@juvare/credentialing/ui/hooks';
import React from 'react';

export function useExtendedUserDirectoryFilters() {
    const { extendCredentialingFilters } = useExtendedCredentialingUserDirectoryFilters();
    const { extendRmsFilters } = useExtendedRmsUserDirectoryFilters();

    const extendFilters = React.useCallback(
        (builder: FilterConfigBuilder<UserDirectoryFilterData>) => {
            extendCredentialingFilters(builder, { regionEnabled: true });
            extendRmsFilters(builder);
        },
        [extendCredentialingFilters, extendRmsFilters],
    );

    return {
        extendFilters,
    };
}
